import {switchClasses, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiSwitch = ({switchInput}: Tokens): ThemeOptions['components'] => ({
  MuiSwitch: {
    defaultProps: {
      color: 'primary',
      disableRipple: true,
      disableFocusRipple: true
    },
    styleOverrides: {
      root: {
        padding: 0,
        height: 20,
        width: 40
      },
      switchBase: {
        padding: 0,
        boxShadow: 'none',
        backgroundColor: switchInput.thumb.desktop.background.color,
        '&:hover': {
          backgroundColor: 'transparent'
        },
        '&:focus-within, &.Mui-focusVisible': {
          outline: 'none'
        },
        [`&.${switchClasses.disabled} .MuiSwitch-thumb`]: {
          borderColor: '#B1B2B4'
        },
        [`&.${switchClasses.disabled}+.MuiSwitch-track`]: {
          backgroundColor: switchInput.track.desktop.background.color,
          borderColor: '#B1B2B4',
          opacity: 1
        },
        [`&.${switchClasses.checked}`]: {
          transform: 'translateX(16px)',
          color: switchInput.thumb.desktop.on.background.color,
          backgroundColor: 'transparent',
          '> .MuiSvgIcon-root': {
            height: switchInput.thumb.desktop.height,
            width: switchInput.thumb.desktop.width
          },
          '&:hover': {
            color: switchInput.thumb.desktop.on.hover.background.color
          }
        },
        [`&.${switchClasses.checked}:hover + .MuiSwitch-track`]: {
          borderColor: switchInput.thumb.desktop.on.hover.border.color
        },
        [`&.${switchClasses.checked}+.MuiSwitch-track`]: {
          backgroundColor: switchInput.track.desktop.on.background.color,
          borderColor: switchInput.track.desktop.on.border.color,
          opacity: 1
        }
      },
      thumb: {
        boxShadow: 'none',
        backgroundColor: switchInput.thumb.desktop.background.color,
        borderColor: switchInput.thumb.desktop.border.color,
        borderStyle: switchInput.thumb.desktop.border.style,
        borderWidth: switchInput.thumb.desktop.border.width,
        borderRadius: switchInput.thumb.desktop.border.radius,
        height: switchInput.thumb.desktop.height,
        width: switchInput.thumb.desktop.width
      },
      track: {
        backgroundColor: switchInput.track.desktop.background.color,
        borderColor: switchInput.track.desktop.border.color,
        borderStyle: switchInput.track.desktop.border.style,
        borderWidth: switchInput.track.desktop.border.width,
        width: switchInput.track.desktop.width,
        height: switchInput.track.desktop.height,
        borderRadius: switchInput.track.desktop.border.radius,
        opacity: 1
      }
    }
  }
});
